import styled from '@emotion/styled'
import { Paper } from '@material-ui/core'

export const Wrapper = styled(Paper)`
  max-width: 610px;
  padding: ${({ theme }) => theme.spacing(5, 12)};
  margin: 0 auto;
`
